import { css } from '@emotion/core'
import { measures } from 'styles/variables'

const { half } = measures

export const pageHeader = css`
  margin-bottom: ${3 * half}px;
`

export const pageToolbar = css`
  display: flex;
  gap: ${2 * half}px;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
`

export const filtersSlot = css`
  flex: 1 1 640px;
  min-width: 0;
`

export const actionsSlot = css`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

export const controlsWrapper = css`
  display: flex;
  justify-content: flex-end;
`

export const tableSection = css`
  display: flex;
  flex-direction: column;
  gap: ${2 * half}px;
`
